// these color constants point to classes in CSS.

// PRIMARY means the brand's primary color:
//   e.g.
//   The Chicago Bears would use Maastricht Blue #0A162B
//   The Texas Longhorns would use Burnt Orange #BF5700
//   Perhaps, the Aggies would choose #500000

// SECONDARY means the brand's secondary color:
//   e.g.
//   The Chicago Bears would use Mahogany #CA3700
//   The Texas Longhorns would use Dark Gray #333F48

//  So if we had the Longhorns as a customer,
//  SECONDARY_COLOR_FOREGROUND therefore points to a class like:
//  .secondary-color-foreground{
//    color: #333F48
//  }

//  OFFSET_SECONDARY_COLOR_FOREGROUND is a color that looks nice against
//   the secondary color.  In this case, white (#FFFFFF) is hard to beat.
//
//  .offset-secondary-color-foreground{
//    color: #FFFFFF
//  }

// USING THESE COLORS:
// We suggest creating elements and tagging them thus:
// <div className={`${colors.SECONDARY_COLOR_BACKGROUND} ${colors.OFFSET_SECONDARY_COLOR_FOREGROUND}`} >Lorem ipsum, etc,</div>
//
// In this example. we would get a dark grey background and the Lorem Ipsum text would appear white.

export const BRANDING_CLASSES = {
  PRIMARY_COLOR_FOREGROUND: "primary-foreground",
  PRIMARY_COLOR_BACKGROUND: "primary-background",
  PRIMARY_COLOR_BACKGROUND_HOVER: "primary-background-hover",
  PRIMARY_COLOR_BORDER: "primary-border",
  PRIMARY_COLOR_BORDER_BOTTOM: "primary-border-bottom",
  PRIMARY_COLOR_UNDERLINE: "primary-underline",
  OFFSET_PRIMARY_COLOR_FOREGROUND: "offset-primary-foreground",
  OFFSET_PRIMARY_COLOR_BACKGROUND: "offset-primary-background",
  OFFSET_PRIMARY_COLOR_BORDER: "offset-primary-border",

  SECONDARY_COLOR_FOREGROUND: "secondary-foreground",
  SECONDARY_COLOR_BACKGROUND: "secondary-background",
  SECONDARY_COLOR_BORDER: "secondary-border",
  SECONDARY_COLOR_UNDERLINE: "secondary-underline",
  OFFSET_SECONDARY_COLOR_FOREGROUND: "offset-secondary-foreground",
  OFFSET_SECONDARY_COLOR_BACKGROUND: "offset-secondary-background",
  OFFSET_SECONDARY_COLOR_BORDER: "offset-secondary-border",

  LINK_COLOR: "link-color",
  TEXT_COLOR: "text-color",
  ALT_TEXT_COLOR: "alt-text-color",
  ALT_TEXT_BORDER: "alt-text-border",
  DISABLED_BACKGROUND: "disabled-background",
  DISABLED_FOREGROUND: "disabled-foreground",

  BUTTON_DEFAULT_BACKGROUND: "default-background",
  BUTTON_DEFAULT_TEXT: "default-foreground",
  BUTTON_PRIMARY: "button--primary",
  BUTTON_PRIMARY_BRANDED: "button--primary--branded",
  BUTTON_SECONDARY: "button--secondary",
  BUTTON_PRIMARY_INVERTED: "button--primary--inverted",
  BUTTON_SYSTEM: "button--system",
  BUTTON_FEATURE: "button--feature",
  BUTTON_FEATURE_INVERTED: "button--feature--inverted",
  BUTTON_FEATURE_ICON_WRAPPER: "button--feature-icon-wrapper",
  BUTTON_FEATURE_INVERTED_ICON_WRAPPER:
    "button--feature--inverted-icon-wrapper",
  LAYOUT_HEADER_FOREGROUND: "layout-header-foreground",

  PILL_GRAY: "pill--gray",
  PILL_OUTLINE: "pill--outline",
  PILL_PRIMARY: "pill--primary",
  PILL_PRIMARY_COLOR: "pill--primary-color",
  PILL_SECONDARY: "pill--secondary",
  PILL_SECONDARY_COLOR: "pill--secondary-color",
  PILL_WARNING: "pill--warning",
  PILL_COUNTER: "pill--counter",

  PRIMARY_MENU_ICON: "primary-menu-icon",
  SECONDARY_MENU_ICON: "secondary-menu-icon",
  SIDENAV_MENU_GROUP_OPEN_CONTAINER: "sidenav-menu-group-open-container",
  SIDENAV_SUB_ITEM: "side-nav-sub-item",
  SIDENAV_ITEM: "sidenav-item",
  SIDENAV_SUB_ITEM_CONTAINER: "side-nav-sub-item-container",
  SIDENAV_SECONDARY_MENU_BUTTON: "side-nav-secondary-menu-button",
  SIDENAV_HOVER_STATE: "side-nav-hover-state",

  CELEBRATION_BACKGROUND: "celebration-background",
  CONFETTI_PATTERN_BACKGROUND: "confetti-pattern-background",
};

/**
 * Actual classes that appear in CSS, not their keys
 */
export const BRANDING_CLASS_VALUES = Object.values(BRANDING_CLASSES);
